// extracted by mini-css-extract-plugin
module.exports = {"msg":"SingleClassValidator_msg__3f2Sm"};